import jhsfBookingsApi from '../apis/jhsfBookingsApi';

export const deleteBookingQueuesService = async (
  bookingQueueId: string,
): Promise<void> => {
  await jhsfBookingsApi.delete(`/booking-queues/${bookingQueueId}`);
};
